export const name = "App";

export const constants = {
  name,
};
